export default "__VITE_ASSET__fY_yh0Ja__"